<template>
  <div class="knowledge-management">
    <div class="knowledge-management-filter">
      <el-select v-model="category" placeholder="请选择" class="select-type" @change="filterLsit">
        <el-option
              label="全部分类"
              value="">
        </el-option>
        <el-option
            v-for="item in categoryList"
            :key="item.classId"
            :label="item.name"
            :value="item.classId">
        </el-option>
      </el-select>
      <el-input placeholder="请输入内容" v-model="searchProblem" class="input-search-problem">
        <el-button slot="append" icon="el-icon-search" @click="filterLsit"></el-button>
      </el-input>
    </div>
    <div class="table-data">
	  <div class="table-box">
		 <el-table
		 :data="tableData" stripe 
		 :header-cell-style="{background:'#f2f2f2'}" 
		 style="border: 1px solid #ebeef5;"
		 >
			<el-table-column
					prop="problem"
					width="50">
				<template slot-scope="scope">
					<el-checkbox
							@change="handleSelectionChange(scope.row)"
							v-model="scope.row.checked"></el-checkbox>
				</template>
			</el-table-column>
		 	<el-table-column label="问题">
		 		<template slot-scope="scope">
		 			<span>{{scope.row.problem}}</span>
		 		</template>
		 	</el-table-column>
		 	<el-table-column label="分类">
		 		<template slot-scope="scope">
		 			<span>{{scope.row.className}}</span>
		 		</template>
		 	</el-table-column>
		 </el-table>
		 <!--    分页-->
		 
		 <pagenations :total="total" :currentPage="currentPage" :size="pageSize" @pageHandler="pageOperate"></pagenations> 
	  </div>
      
    </div>
  </div>
</template>

<script>
  import pagenations from '@/components/pagenations/pagenations'

  export default {
    components: {
      pagenations
    },
	props:['SelectionData'],
    data() {
      return {
        currentPage: 1,
        pageSize: 10,
        searchProblem:'',
        category:'',
        categoryList:[],
        tableData: [],
        total: 0,
		selectionData: [],
		isReserve: true
      }
    },
    created() {
	  this.selectionData = this.SelectionData
      this.getClassList()
    },
    mounted() {
      eventBus.$on("reloadProblemTable",() => {
        this.getKnowledgeList()
      })
    },
    methods: {
		// 选择表格中的数据
		handleSelectionChange(row) {
		  console.log(row.checked,this.selectionData.length)
		  if(this.selectionData.length <= 10){
			  this.tableData.forEach((item,ind) => {
				  if(row.problemId == item.problemId){
					  let newItem = Object.assign({},item)
					  if(this.selectionData.length == 10 && row.checked){
						  newItem.checked = false
					  }else{
						  newItem.checked = row.checked
					  }
					  
					  this.tableData.splice(ind,1,newItem)
				  }
			  })
			  if(this.selectionData.length == 10 && row.checked){
				  this.$message.warning('最多添加10个关联问题')
				  return false
			  }
		  }
		  
		  if(row.checked){
			  this.selectionData.push({
				  problemId: row.problemId,
				  problem: row.problem
			  })
		  }else{
			  this.selectionData.forEach((select,ind) => {
				  if(row.problemId == select.problemId){
					 this.selectionData.splice(ind,1)  
				  }
			  })
		  }
		},
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getKnowledgeList()
      },
      getKnowledgeList(){
        this.$http.getKnowledgeListAPI({
          id:this.category,
          name:this.searchProblem,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
        }).then(res => {
          if(res.status == 1){
            this.tableData = res.data.list
			this.tableData.forEach(row => {
				row.checked = false
				this.selectionData.forEach(select => {
					if(select.problemId == row.problemId){
						row.checked = true
					}
				})
			})
            this.total = res.data.total
          }
        })
      },
      getClassList(){
        this.$http.getClassListAPI({
          pageNum: 1,
          pageSize:500
        }).then( res => {
          if(res.status == 1){
            this.categoryList = res.data.list
            eventBus.$emit("getClass",res.data.list)
            if(res.data.list.length > 0){
              // this.category = res.data.list[0].classId
              this.getKnowledgeList()
            }

          }
        })
      },
	  editMethods(row){
	  	eventBus.$emit('editProblem',row)
	  },
      delProblem(type,id){
		  let idArr = []
		  if (type == "delSingle") {
		  	idArr.push(id)
		  } else if (type == "delAll") {
		  	if (id.length == 0) {
		  		this.$message({
		  			message: '请选择要删除的数据',
		  			type: 'error'
		  		})
		  		return false
		  	}
		  	id.forEach((item, index) => {
		  		idArr.push(item.problemId)
		  	})
		  }
		  this.$confirm('将要进行删除操作, 是否继续?', '提示', {
		  	confirmButtonText: '确定',
		  	cancelButtonText: '取消',
		  	type: 'warning'
		  }).then(() => {
		  	this.$http.delProblemAPI(idArr).then( res => {
		  	  if(res.status == 1){
		  	    this.getKnowledgeList()
		  	    this.$message({
		  	      message: res.msg,
		  	      type: 'success',
		  	    })
		  	  }else {
		  	    this.$message({
		  	      message: res.msg,
		  	      type: 'error',
		  	    })
		  	  }
		  	})
		  }).catch(() => {})
		  
        
      },
      filterLsit(){
		this.currentPage = 1
        this.getKnowledgeList()
      },
    }
  }
</script>

<style lang="scss">
  .knowledge-management {
    .knowledge-management-filter{
      display: flex;
      .input-search-problem{
        width: 300px;
        margin-left: 20px;
      }
    }
    .select-type{
      width: 300px;
    }
	.wl-btn-del{
		margin-left: 15px;
	}
    .table-data{
      position: relative;
    }
  }
</style>
